import type { GameMeta } from '@gmp/game-sdk';

export const dealbreakersMeta = {
  id: 'dealbreakers',
  name: 'Dealbreakers',
  tagline: 'A dream offer, a pile of ridiculous conditions, and one big question: deal or no deal?',
  description:
    'Each round one player is offered something wonderful: a mansion, a pet dragon, unlimited pizza. Everyone else secretly adds one bizarre condition ("…but it\'s haunted by a mime"). The recipient walks through the conditions one at a time, accepting or walking away, while everyone else predicts where the deal breaks. Then the stack flips: DEAL or NO DEAL. Play over a coffee break or over a week.',
  minPlayers: 3,
  maxPlayers: 10,
  estimatedMinutes: [15, 30],
  usesMedia: false,
  modes: [{ id: 'offers', name: 'Offers', description: 'One offer per player by default, so everyone is the recipient once.' }],
  theme: { primary: '#f5c542', secondary: '#ff4f7b', background: '#150f26', ink: '#fff7e8' },
  readiness: 'beta',
  genre: 'Ridiculous offers and social prediction',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [20, 60],
    match: { quick: '15–30 min', daily: '4–10 days' },
    difficulty: 'easy',
    tags: ['funny', 'social', 'prediction'],
  },
  instructions: [
    { icon: 'Gift', title: 'The offer', body: 'Each round one player gets a tempting offer. The role rotates so everyone gets one.' },
    { icon: 'PenLine', title: 'Add a condition', body: 'Everyone else secretly writes one bizarre condition: "…but it\'s haunted by a mime." The server shuffles them.' },
    { icon: 'Handshake', title: 'Deal or no deal?', body: 'The recipient walks through the conditions one by one and accepts or rejects. Everyone else predicts the breaking point; the recipient guesses what the group predicted.' },
    { icon: 'Trophy', title: 'The reveal', body: 'The stack flips. The condition that broke the deal scores its writer; good predictions score too. Play at your own pace: steps move on when everyone is in or the time runs out.' },
  ],
} satisfies GameMeta;
